import { Backdrop, Card, CardContent, CardHeader, Checkbox, CircularProgress, Container, Divider, Snackbar, TextField, Button, Grid, InputAdornment, Menu, MenuItem, OutlinedInput, Pagination, Typography, Tooltip, IconButton, Fab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Modal, FormControlLabel, DialogActions } from '@mui/material';
import EmployeeCard from 'src/components/cards/EmployeeCard';
import Alert from 'src/components/Alert';
import { useTheme } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DirectionsIcon from '@mui/icons-material/Directions';
import { getUser, setUserAydinlatmaMetni } from 'src/utils/Common';
import Page from 'src/components/Page';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ListIcon from '@mui/icons-material/List';
import * as XLSX from 'xlsx';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { visuallyHidden } from '@mui/utils';
import axios from 'src/utils/axios';
import PropTypes from 'prop-types';
import { sc } from 'src/utils/Common';
import MainCard from 'src/components/cards/MainCard';
import UserDetailsCard from 'src/components/cards/UserDetailsCard';
import PrintIcon from '@mui/icons-material/PrintTwoTone';
import FileCopyIcon from '@mui/icons-material/FileCopyTwoTone';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Chip from 'src/components/extended/Chip';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import Avatar from 'src/components/extended/Avatar'
import GridOffIcon from '@mui/icons-material/GridOff';
import SubCard from 'src/components/cards/SubCard';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Profile from 'src/components/account-profile/Profile1';
import DialogTitle from '@mui/material/DialogTitle';
import FilterSpeedDialNew from 'src/components/FilterSpeedDialNew';
import BackHandIcon from '@mui/icons-material/BackHand';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import * as pdfjsLib from 'pdfjs-dist';
import { Viewer } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import 'src/assets/css/aydinlatma_metni.css'; // Move styles to this CSS file

// PDF dosyasını import et
import AydinlatmaMetni from 'src/assets/pdf/Arçelik_Yetkili Servis_Çalışanı_Yetkilisi_Aydınlatma_Metni.pdf'





const avatarImage = require.context('src/assets/images/users', true);

// table sort
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const getComparator = (order, orderBy) =>
  order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// table header options
const headCells = [
  {
    id: 'name',
    numeric: false,
    label: 'Resim',
    align: 'left'
  },
  {
    id: 'name2',
    numeric: false,
    label: 'Çalışan',
    align: 'left'
  },
  {
    id: 'role',
    numeric: true,
    label: 'ÇalışanTipi',
    align: 'left'
  },
  {
    id: 'about',
    numeric: true,
    label: 'Hakkında',
    align: 'left'
  },
  {
    id: 'email',
    numeric: true,
    label: 'Email',
    align: 'left'
  },
  {
    id: 'contact',
    numeric: true,
    label: 'Telefon',
    align: 'left'
  },
  // {
  //   id: 'Kvkk',
  //   numeric: false,
  //   label: 'Kvkk',
  //   align: 'left'
  // },
  // {
  //   id: 'KvkkDate',
  //   numeric: false,
  //   label: 'KvkkTarih',
  //   align: 'left'
  // },
  {
    id: 'status',
    numeric: false,
    label: 'Durum',
    align: 'left'
  }
];

// ==============================|| TABLE HEADER ||============================== //

function EnhancedTableHead({ onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, theme, selected }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {numSelected > 0 && (
          <TableCell padding="none" colSpan={7}>
            <EnhancedTableToolbar numSelected={selected.length} />
          </TableCell>
        )}
        {numSelected <= 0 &&
          headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablepadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        {numSelected <= 0 && (
          <TableCell sortDirection={false} align="center" sx={{ pr: 3 }}>
            <Typography variant="h6" sx={{ color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900' }}>
              İşlem
            </Typography>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  theme: PropTypes.object,
  selected: PropTypes.array,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

// ==============================|| TABLE HEADER TOOLBAR ||============================== //

const EnhancedTableToolbar = ({ numSelected }) => (
  <Toolbar
    sx={{
      p: 0,
      pl: 1,
      pr: 1,
      ...(numSelected > 0 && {
        color: (theme) => theme.palette.secondary.main
      })
    }}
  >
    {numSelected > 0 ? (
      <Typography color="inherit" variant="h4">
        {numSelected} Selected
      </Typography>
    ) : (
      <Typography variant="h6" id="tableTitle">
        Nutrition
      </Typography>
    )}
    <Box sx={{ flexGrow: 1 }} />
    {numSelected > 0 && (
      <Tooltip title="Delete">
        <IconButton size="large">
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </Toolbar>
);

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};

function exportToExcel(data, fileName) {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}

function FilterModal({ open, onClose, onFilter }) {
  const [activeChecked, setActiveChecked] = useState(true);
  const [inactiveChecked, setInactiveChecked] = useState(true);
  const [phoneValue, setPhoneValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [cityValue, setCityValue] = useState('');

  const handleActiveCheckedChange = (event) => {
    setActiveChecked(event.target.checked);
  };

  const handleInactiveCheckedChange = (event) => {
    setInactiveChecked(event.target.checked);
  };

  const handlePhoneChange = (event) => {
    setPhoneValue(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
  };

  const handleCityChange = (event) => {
    setCityValue(event.target.value);
  };

  const handleFilterClick = () => {
    const filterData = {
      active: activeChecked,
      inactive: inactiveChecked
    };
    onFilter(filterData);
    onClose();
  };





  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <SubCard title="Filtrele">
          <Grid container spacing={2}>
            <Grid size={2}></Grid>
            <Grid size={4}>
              <FormControlLabel
                control={<Checkbox checked={activeChecked} onChange={handleActiveCheckedChange} />}
                label="Aktif"
              />
            </Grid>
            <Grid size={4}>
              <FormControlLabel
                control={<Checkbox checked={inactiveChecked} onChange={handleInactiveCheckedChange} />}
                label="Pasif"
              />
            </Grid>
            <Grid size={2}></Grid>
            <br />
            <Grid size={12}>
              <Button variant="contained" fullWidth onClick={handleFilterClick} color="secondary">
                Filtrele
              </Button>
            </Grid>
          </Grid>
        </SubCard>
      </Box>
    </Modal>
  );
}
function EmployeeMain() {
  const { id: employeeMainId } = useParams();
  const theme = useTheme();
  const [openEditPopUp, setOpenEditPopUp] = useState(false);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [loading, setLoading] = useState(false);
  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const SessionUser = getUser();
  const [usersData, setusersData] = React.useState([]);
  const [users, setusers] = React.useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [OrganizationIdParam, setOrganizationIdParam] = React.useState(0);
  const [imageDataList, setImageDataList] = useState([]);
  const [openEditPopUpEdit, setOpenEditPopUpEdit] = useState(false);
  // drawer
  const [open, setOpen] = useState(isLoading);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const isUsedBefore = (name) => (selectedAll && selectedAll.indexOf(name) !== -1);


  // 
  const [OrganizationControl, setOrganizationControl] = React.useState(0);
  const [gridSpacing, setgridSpacing] = React.useState(3);
  const [responseMessage, setresponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [EmployeeName, setEmployeeName] = useState("");
  const [EmployeeRole, setEmployeeRole] = useState("");
  const [employeeDealerGroup, setEmployeeDealerGroup] = useState("");

  const [srcAktif, setsrcAktif] = useState(true);
  const [srcPasif, setsrcPasif] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };





  const filterOptions1 = (options, { inputValue }) => {
    const inputUpperCase = inputValue.toLowerCase();
    return options.filter((option) =>
      option.Dsc.toLowerCase().includes(inputUpperCase.replace('ı', 'i'))
    );
  };


  const handleFilter = (filterData) => {
    // Filtreleme işlemlerini burada gerçekleştirin

    var newString = "";

    if (filterData.active === false && filterData.inactive === true) {
      newString = "Pasif";
    }

    if (filterData.active === true && filterData.inactive === false) {
      newString = "Aktif";
    }
    if (filterData.active === true && filterData.inactive === true) {
      newString = "1";
    }
    if (filterData.active === false && filterData.inactive === false) {
      newString = "Boş";
    }

    if (newString === "1") {
      setusers(usersData);
    } else {
      setusers(usersData.filter(item =>
        sc(item.status, newString)
      ));
    }




  };




  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState(null);
  const [SelectedBirim, setSelectedBirim] = React.useState(null);
  const [OpenChangeList, setOpenChangeList] = React.useState(false);
  const [EmployeeNr, setEmployeeNr] = React.useState(0);
  // const [Kvkk, setKvkk] = React.useState(0);
  // const [KvkkPhone, setKvkkPhone] = React.useState('');
  // const [KvkkEmail, setKvkkEmail] = React.useState('');

  const [NameParam, setNameParam] = React.useState('');
  const [SurnameParam, setSurnameParam] = React.useState('');
  const [role, setrole] = React.useState('');
  const [StatusId, setStatusId] = React.useState(0);

  const [DealerGroup, setDealerGroup] = React.useState([]);
  const [selectedDealerGroup, setselectedDealerGroup] = React.useState(null);
  const [OrganizationTypeId, setOrganizationTypeId] = React.useState(0);
  const [DealerCompany, setDealerCompany] = React.useState([]);
  const [selectedDealerCompany, setSelectedDealerCompany] = React.useState(null);
  const [loadingCombo, setLoadingCombo] = useState(true);

  const [DealerArea, setDealerArea] = React.useState([]);
  const [selectedDealerArea, setSelectedDealerArea] = React.useState(null);
  const [Dealer, setDealer] = React.useState([]);
  const [selectedDealer, setSelectedDealer] = React.useState(null);
  const [selectedSalesRepDealer, setSelectedSalesRepDealer] = React.useState(null);
  const [salesRepDealer, setSalesRepDealer] = React.useState([]);
  const [OpenShowPopUp, setOpenShowPopUp] = React.useState(false);
  const params = new URLSearchParams(location.search)
  const tempBolge = params.get('selectedBolge');
  const tempServis = params.get('selectedServis');
  const tempEmployeeType = params.get('selectedEmployeeType');
  const [bolgeParam, setBolgeParam] = React.useState(tempBolge);
  const [servisParam, setServisParam] = React.useState(tempServis);
  const isRedirected = params !== undefined;

  const [isShow, setIsShow] = useState(true);

  useEffect(() => {
    getBolgeAdiKoduData();
    setOrganizationControl(employeeMainId);
    GetDealerGroupData();
    setisLoading(false);
  }, []);

  useEffect(() => {
    getDetail(SelectedBirim?.BirimKodu)
  }, [SelectedBirim]);

  useEffect(() => {
    if (SessionUser.ShowAydinlatmaMetni === 1 && SessionUser.ManagementRoleId === 6) {
      setOpenMetin(true);
    }
  }, []);

  const GetEmployeeDataForRoles = (Bolge, Servis, Role) => {
    console.log(Bolge);
    console.log(Servis);
    console.log(Role);
  }


  const GetDealerSalesRepData = (Area, Company, Group) => {

    setLoadingCombo(true);

    if (Company === "") {
      Company = selectedDealerCompany?.Id;
    }
    if (Group === "") {
      Group = selectedDealerGroup?.Id;
    }

    axios.get(`GetDealerSalesRepData/${Group}/${Company}/${Area}`).then((response) => {
      setSalesRepDealer(response.data);
      if (response?.data?.length === 1) {
        setSelectedSalesRepDealer(response?.data[0]);
        GetDealerData(Area, Company, Group, response?.data[0]?.Id);
      }
      setLoadingCombo(false);
    }).catch((error) => {
      setLoadingCombo(false);
    });
  }

  const GetDealerData = (Area, Company, Group, SalesRep) => {
    setLoadingCombo(true);

    if (Company === "") {
      Company = selectedDealerCompany?.Id;
    }
    if (Group === "") {
      Group = selectedDealerGroup?.Id;
    }
    if (Area === "") {
      Area = selectedDealerArea?.Id;
    }

    axios.get(`GetDealerData/${Group}/${Company}/${Area}/${SalesRep}`).then((response) => {
      setDealer(response.data);
      if (response?.data?.length === 1) {
        setSelectedDealer(response?.data[0]);
        setPage(0);
        getDetail(response?.data[0]?.Id);
      }
      setLoadingCombo(false);
    }).catch((error) => {
      setLoadingCombo(false);
    });
  }

  const GetDealerAreaData = (Company, Group) => {
    setLoadingCombo(true);
    if (Group === "") {
      Group = selectedDealerGroup?.Id;
    }
    axios.get(`GetDealerAreaData/${Group}/${Company}`).then((response) => {
      setDealerArea(response.data);
      if (response?.data?.length === 1) {
        setSelectedDealerArea(response?.data[0]);
        GetDealerSalesRepData(response?.data[0]?.Id, Company, Group);
        //GetDealerData(response?.data[0]?.Id, Company, Group);
      }
      setLoadingCombo(false);
    }).catch((error) => {
      setLoadingCombo(false);
    });
  }

  const GetDealerCompanyData = (Group) => {
    setLoadingCombo(true);
    axios.get(`GetDealerCompanyData/${Group}`).then((response) => {
      setDealerCompany(response.data);
      if (response?.data?.length === 1) {
        setSelectedDealerCompany(response?.data[0]);
        GetDealerAreaData(response?.data[0]?.Id, Group)
      }
      setLoadingCombo(false);
    }).catch((error) => {
      setLoadingCombo(false);
    });

  }

  const GetDealerGroupData = () => {
    setLoadingCombo(true);
    axios.get(`GetDealerGroupData`).then((response) => {
      setDealerGroup(response.data);
      if (response?.data?.length === 1) {
        setselectedDealerGroup(response?.data[0]);
        GetDealerCompanyData(response?.data[0]?.Id);
      }
      setLoadingCombo(false);
    }).catch((error) => {
      setLoadingCombo(false);
    });

  }

  const getBolgeAdiKoduData = () => {
    if (isRedirected == false) {
      setLoadingCombo(true);
      axios.get(`GetTopServiceCode/${SessionUser.TopServiceShopCode}`).then((response) => {
        var Data = response.data;
        var newData = Data.filter((item) => item?.BirimKodu !== "0");
        setBolgeAdiKodu(newData);
        if (newData.length == 1) {
          setSelectedbolgeAdiKodu(newData[0])
          getBirimData(newData[0]?.BirimKodu);
        }
        setLoadingCombo(false);
      }).catch((error) => {
        setLoadingCombo(false);
      });
    }
    else {
      setLoadingCombo(true);
      axios.get(`GetTopServiceCode/${SessionUser.TopServiceShopCode}`).then((response) => {
        var Data = response.data;
        var newData = Data.filter((item) => item?.BirimKodu !== "0");
        setBolgeAdiKodu(newData);
        var selectedBolgeItem = newData.find(item => item.BirimKodu === bolgeParam);
        setSelectedbolgeAdiKodu(selectedBolgeItem || null)
        getBirimData(bolgeParam);
        setLoadingCombo(false);
      }).catch((error) => {
        setLoadingCombo(false);
      });

    }

  }

  const getBirimData = (BirimKodu) => {
    if (isRedirected == false) {
      var tempBirim = SessionUser.ManagementRoleId == 4 || SessionUser.ManagementRoleId == 6 ? SessionUser.ServiceShopId : BirimKodu
      setLoadingCombo(true);
      if (tempBirim == null) {
        setBirimData([]);
        setLoadingCombo(false);
      } else {

        axios.get(`GetBirimData/${tempBirim}`).then((response) => {
          setBirimData(response.data);
          if (response.data.length == 1) {
            setSelectedBirim(response.data[0])
          }
          setLoadingCombo(false);
        }).catch((error) => {
          setLoadingCombo(false);
        });
      }
    }
    else {
      var tempBirim = SessionUser.ManagementRoleId == 4 || SessionUser.ManagementRoleId == 6 ? SessionUser.ServiceShopId : BirimKodu
      setLoadingCombo(true);
      if (tempBirim == null) {
        setBirimData([]);
        setLoadingCombo(false);
      } else {
        axios.get(`GetBirimData/${tempBirim}`).then((response) => {
          setBirimData(response.data);
          var Data = response.data;
          var selectedBirimItem = Data.find(item => item.BirimKodu == servisParam);
          setSelectedBirim(selectedBirimItem || null)
          setLoadingCombo(false);
        }).catch((error) => {
          setLoadingCombo(false);
        });
      }
    }

  }

  const getDetail = (value) => {
    setLoading(true);
    var OrganizationId;
    setSearch("");

    if (employeeMainId === "2") {
      OrganizationId = value === 0 ? selectedDealer?.Id : value;
    } else {
      OrganizationId = value === 0 ? SelectedBirim?.BirimKodu : value;
    }
    setOrganizationIdParam(OrganizationId);

    if (OrganizationId === undefined) {
      setLoading(false);
      return;
    }

    setsrcAktif(true);
    setsrcPasif(false);

    axios
      .get(`GetEmployeeData/${OrganizationId}/${employeeMainId}/0`)
      .then((response) => {
        setLoading(false);
        if (response.data.length > 0) {

          setusers(response.data.filter(item =>
            sc(item.status, "Aktif")
          ));

          if (tempEmployeeType) {
            setusers(response.data.filter(item =>
              sc(item.status, "Aktif") && item.role === tempEmployeeType
            ));
          }

          setusersData(response.data);
        } else {
          setusers([]);
          setusersData([]);
        }
      })
      .catch((error) => {
        setLoading(false);
      });

  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [search, setSearch] = React.useState('');
  const handleSearch = async (event) => {
    const newString = event?.target.value;

    setSearch(newString);

    if (newString) {
      setusers(usersData.filter(item =>
        sc(item.id, newString)
        || sc(item.name, newString)
        || sc(item.role, newString)
        || sc(item.about, newString)
        || sc(item.email, newString)
        || sc(item.contact, newString)
        || sc(item.location, newString)
        || sc(item.status, newString)
      ))
    } else {
      setusers(usersData);
    }
  };

  const handleDrawerOpen = () => {
    setOpen((prevState) => !prevState);
  };

  const SetChangeList = () => {
    if (OpenChangeList === false) {
      setOpenChangeList(true);
    } else {
      setOpenChangeList(false);
    }
  };


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      if (selected.length > 0) {
        setSelected([]);
      } else {
        const newSelectedId = users.map((n) => n.name);
        setSelected(newSelectedId);
      }
      return;
    }
    setSelected([]);
  };

  const handleClickTable = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const handleExportClick = () => {
    var kulBirimKoduAdi = "";
    OrganizationControl === "1" ? kulBirimKoduAdi = SelectedBirim?.Dsc : kulBirimKoduAdi = selectedDealer?.Dsc;

    var excelData = [];
    users?.map((item) => {
      var data = {
        "Eleman No": item.id,
        "Adı Soyadı": item.name.split('-')[1].trim(),
        "Çalışan Tipi": item.role,
        "Hakkında": item.about,
        "Email": item.email,
        "Telefon": item.contact.replace(/[^0-9]/g, ''),
        "İl": item.location,
        "Durum": item.status,
      }
      excelData.push(data);
    })
    ExcelFileCreator(excelData, `${kulBirimKoduAdi} Çalışan Listesi`);
  };

  let usersResult = <></>;
  if (users) {

    usersResult = users?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((user, index) => (

      <Grid
        key={index}
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
          xl: 3
        }}>
        <UserDetailsCard {...user} />
      </Grid>
    ));
  }

  const NewEmployeeGet1 = (EmployeeNrParam) => {
    setOpenEditPopUp(false);
    setEmployeeNr(EmployeeNrParam);
    setOpenEditPopUpEdit(true);
  }


  const setEmployeeNew = () => {
    if (OrganizationIdParam === undefined || OrganizationIdParam === 0 || OrganizationIdParam === "") {
      setWarningType("error");
      if (OrganizationControl === "1") {
        setresponseMessage("Lütfen Servis Seçiniz!...");
      } else {
        setresponseMessage("Lütfen Bayi Seçiniz!...");
      }
      setWarning(true);
    } else {
      setOpenEditPopUp(true);
    }
  }

  const setOpenEditPopUpEditParam = (EmployeeNr, OrganizationTypeId, OrganizationId,
    NameParam, SurnameParam, role, StatusId) => {
    setEmployeeNr(EmployeeNr);
    // setKvkk(KvkkParam);
    // setKvkkPhone(KvkkPhoneParam);
    // setKvkkEmail(KvkkEmailParam);
    setNameParam(NameParam);
    setSurnameParam(SurnameParam);
    setrole(role);
    setStatusId(StatusId);
    setOpenEditPopUpEdit(true);
  }

  const setOpenShowPopUpParam = (EmployeeNr, EmployeeName, EmployeeRole, EmployeeDealerGroup) => {
    setEmployeeNr(EmployeeNr);
    setEmployeeName(EmployeeName);
    setEmployeeRole(EmployeeRole);
    setEmployeeDealerGroup(EmployeeDealerGroup);
    setOpenShowPopUp(true);
  }

  const handleQuery = () => {
    setLoading(true);
    var OrganizationId;
    setsrcAktif(true);
    setsrcPasif(true);
    axios
      .get(`GetEmployeeData/${0}/${OrganizationControl}/${search}`)
      .then((response) => {
        setLoading(false);
        if (response.data.length > 0) {
          setusers(response.data);
          setusersData(response.data);
        } else {
          setusers([]);
          setusersData([]);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  const handleChangeSrcAktif = () => {
    var Aktif;
    var Pasif = srcPasif;
    if (srcAktif) {
      setsrcAktif(false);
      Aktif = false;
    } else {
      setsrcAktif(true);
      Aktif = true;
    }

    if (Pasif === true && Aktif === true) {
      setusers(usersData);
      return;
    }
    if (Pasif === false && Aktif === true) {
      setusers(usersData.filter(item =>
        sc(item.status, "Aktif")
      ));
      return;
    }
    if (Pasif === true && Aktif === false) {
      setusers(usersData.filter(item =>
        sc(item.status, "Pasif")
      ));
    }
    if (Pasif === false && Aktif === false) {
      setusers([]);
    }


  }
  const handleChangeSrcPasif = () => {
    var Aktif = srcAktif;
    var Pasif;
    if (srcPasif) {
      setsrcPasif(false);
      Pasif = false;
    } else {
      setsrcPasif(true);
      Pasif = true;
    }
    if (Pasif === true && Aktif === true) {
      setusers(usersData);
      return;
    }
    if (Pasif === false && Aktif === true) {
      setusers(usersData.filter(item =>
        sc(item.status, "Aktif")
      ));
      return;
    }
    if (Pasif === true && Aktif === false) {
      setusers(usersData.filter(item =>
        sc(item.status, "Pasif")
      ));
    }
    if (Pasif === false && Aktif === false) {
      setusers([]);
    }


  }
  const [openMetin, setOpenMetin] = useState(false);
  const aydinlatmaToolbarPluginInstance = toolbarPlugin();

  useEffect(() => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
  }, []);



  const handleCloseMetin = () => {
    setOpenMetin(false);
    var data = {
      SICIL_NO: SessionUser.UserId,
      IS_SHOW: 1
    };
    var headers = {
      'Content-Type': 'application/json',
    };
    axios.post('/SetEmployeeShowMetin', data, headers).then((response) => {
      setUserAydinlatmaMetni();
    }
    );
  };





  return (
    <Page>
        <Backdrop open={loading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={Warning}
          autoHideDuration={10000}
          onClose={WarningClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={WarningClose} variant={WarningType} message={responseMessage}></Alert>
        </Snackbar>
        <br />
        <Container maxWidth="xl">
          <Card>
            <CardHeader
              title={<Typography variant="h4">Çalışan Yönetimi</Typography>}
            />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid
                  style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 6
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedbolgeAdiKodu}
                    options={bolgeAdiKodu}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setSelectedbolgeAdiKodu(newValue);
                      getBirimData(newValue?.BirimKodu);
                      setSelectedBirim(null)
                      setusers([]);
                      setusersData([]);
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }} />}

                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 6
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={SelectedBirim}
                    options={BirimData}
                    filterOptions={filterOptions1}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setSelectedBirim(newValue);
                      setPage(0);
                      getDetail(newValue?.BirimKodu)
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Servis" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}

                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedDealerGroup}
                    options={DealerGroup}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setselectedDealerGroup(newValue);
                      GetDealerCompanyData(newValue?.Id);
                      setSelectedDealerCompany(null);
                      setSelectedDealerArea(null);
                      setSelectedDealer(null);
                      setDealer([])
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Direktörlük" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedDealerCompany}
                    options={DealerCompany}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setSelectedDealerCompany(newValue);
                      GetDealerAreaData(newValue?.Id, "");

                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Şube" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}

                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedDealerArea}
                    options={DealerArea}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setSelectedDealerArea(newValue);
                      GetDealerSalesRepData(newValue?.Id, "", "");
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedSalesRepDealer}
                    options={salesRepDealer}
                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setSelectedSalesRepDealer(newValue);
                      GetDealerData("", "", "", newValue?.Id);
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Satış Temsilcisi" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                  />
                </Grid>
                <Grid
                  style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 4
                  }}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    fullWidth
                    value={selectedDealer}
                    options={Dealer}
                    getOptionLabel={(option) => { return option.Id ? (option.Id + ' - ' + option.Dsc) : '-' }}
                    onChange={(event, newValue) => {
                      setSelectedDealer(newValue);
                      setPage(0);
                      getDetail(newValue?.Id);
                    }}
                    loading={loadingCombo}
                    renderInput={(params) => <TextField {...params} label="Bayi" variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingCombo && <CircularProgress color="primary" size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <br />
          <MainCard
            title={
              <Grid container spacing={2} justifyContent="space-between" >
                <Grid item xs={12} sm={4}>
                  <OutlinedInput
                    fullWidth
                    id="input-search-card-style1"
                    placeholder="Arama"
                    value={search}
                    onChange={handleSearch}
                    autoComplete="off"
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon stroke={1.5} size="16px" />
                      </InputAdornment>
                    }
                    endAdornment={  // Yeni kısım: Sorgulama butonu
                      <InputAdornment position="end">
                        <IconButton color="primary" onClick={handleQuery}>
                          <DirectionsIcon stroke={1.5} />
                        </IconButton>
                      </InputAdornment>
                    }
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControlLabel
                    control={<Checkbox
                      checked={srcAktif}
                      onChange={handleChangeSrcAktif}
                      style={{ color: 'green' }}
                      name="Aktif" />}
                    label="Aktif"
                  />
                  <FormControlLabel
                    control={<Checkbox
                      checked={srcPasif}
                      onChange={handleChangeSrcPasif}
                      style={{ color: 'red' }}
                      name="Pasif" />}
                    label="Pasif"
                  />
                </Grid>
                {/* <Grid item xs={12} sm={3}>
                  <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={users.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Grid> */}
                <Grid item xs={12} sm={5} sx={{ textAlign: 'right' }}>
                  <Tooltip title="Görünümü Değiştir">
                    <IconButton
                      size="large"
                      onClick={(event) => SetChangeList()}
                      sx={{
                        '&:hover': { backgroundColor: '#FF9800 !important', },
                      }}
                    >
                      {OpenChangeList ? <GridOffIcon /> : <ListIcon />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Filtre">
                    <IconButton
                      size="large"
                      onClick={handleOpenModal}
                      sx={{
                        '&:hover': { backgroundColor: '#FF9800 !important', },
                      }}
                    >
                      <FilterAltIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Sorgula">
                    <IconButton
                      size="large"
                      onClick={() => getDetail(0)}
                      sx={{
                        '&:hover': { backgroundColor: '#FF9800 !important', },
                      }}
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Çalışan Ekle">
                    <IconButton
                      size="large"
                      sx={{
                        '&:hover': { backgroundColor: '#FF9800 !important', },
                      }}
                      onClick={() => setEmployeeNew()}
                    >
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            }
          >
            <Grid container direction="row" spacing={gridSpacing}>
              {OpenChangeList === false ? usersResult : ''}
              {/* table */}

              <TableContainer style={{ display: OpenChangeList === true ? 'block' : 'none' }}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={users?.length}
                    theme={theme}
                    selected={selected}
                  />
                  <TableBody>
                    {stableSort(users, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        /** Make sure no display bugs if row isn't an OrderData object */
                        if (typeof row === 'number') return null;
                        const isItemSelected = isSelected(row.name);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={index}
                            selected={isItemSelected}
                          >
                            <TableCell><Avatar alt={row.name} size="lg" src={row.avatar} /></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.name}</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.role}</TableCell>
                            <TableCell title={row.about} sx={{ whiteSpace: 'nowrap' }}>{row.about.substring(1, 30) + '...'}</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.email}</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.contact}</TableCell>
                            {/* <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                              {row.Kvkk === 1 && <VerifiedUserIcon style={{ color: 'green' }} size="small" />}
                              {row.Kvkk === 0 && <VerifiedUserIcon style={{ color: 'red' }} size="small" />}
                            </TableCell> */}
                            {/* <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.KvkkDate}</TableCell> */}
                            <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                              {row.status === 'Aktif' && <Chip label="Aktif" style={{ backgroundColor: '#90EE90', color: 'white' }} size="small" />}
                              {row.status === 'Pasif' && <Chip label="Pasif" style={{ backgroundColor: 'tomato', color: 'white' }} size="small" />}
                            </TableCell>
                            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                              <IconButton color="primary"
                                size="large" aria-label="view"
                                onClick={() => setOpenShowPopUpParam(row.id, row.name, row.role, row.DealerGroup)}
                              >
                                <VisibilityTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                              </IconButton>
                              <IconButton color="secondary"
                                size="large" aria-label="edit"
                                onClick={() => setOpenEditPopUpEditParam(row.id, row.OrganizationTypeId, row.serviceShopId, row.NameParam, row.SurnameParam, row.role, row.StatusId)}
                              >
                                <EditTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: 53 * emptyRows
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid size={12}>
                <Grid container justifyContent="space-between" spacing={gridSpacing}>
                  <Grid>
                    {/* table pagination */}
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      component="div"
                      count={users.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
            <FilterModal open={openModal} onClose={handleCloseModal} onFilter={handleFilter} />
          </MainCard>
        </Container>
        <Dialog
          fullScreen
          open={openEditPopUp}
          sx={{ '& .MuiDialog-paper': { maxHeight: 800, minHeight: 800 } }}
          onClose={() => setOpenEditPopUp(false)}

        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            Çalışan Detayı
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpenEditPopUp(false)}
              aria-label="close"
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>

            <Profile EmployeeNr={0}
              OrganizationTypeId={OrganizationControl}
              ServiceShopId={OrganizationIdParam}
              NewEmployeeGet1={NewEmployeeGet1}
              Name={''}
              Surname={''}
              PersonelType={''}
              StateId={1}
            />
          </DialogContent>
        </Dialog>
        <Dialog
          fullScreen
          open={openEditPopUpEdit}
          sx={{ '& .MuiDialog-paper': { maxHeight: 800, minHeight: 800 } }}
          onClose={() => setOpenEditPopUpEdit(false)}

        >
          <DialogTitle
            size="small"
            id="responsive-dialog-title"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            Çalışan Detayı
            <IconButton
              edge="end"
              size="small"
              color="inherit"
              onClick={() => setOpenEditPopUpEdit(false)}
              aria-label="close"
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Profile EmployeeNr={EmployeeNr}
              OrganizationTypeId={OrganizationControl}
              ServiceShopId={OrganizationIdParam}
              // Kvkk={Kvkk}
              // KvkkPhone={KvkkPhone}
              // KvkkEmail={KvkkEmail}
              Name={NameParam}
              Surname={SurnameParam}
              PersonelType={role}
              StateId={StatusId} />
          </DialogContent>
        </Dialog>
        <Dialog
          open={OpenShowPopUp}
          onClose={() => setOpenShowPopUp(false)}>
          <EmployeeCard
            EmployeeNr={EmployeeNr}
            EmployeeName={EmployeeName}
            EmployeeRole={EmployeeRole}
            EmployeeDealerGroup={employeeDealerGroup}
          />
          <DialogActions>
            <Button onClick={() => setOpenShowPopUp(false)} autoFocus>
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openMetin}
          onClose={handleCloseMetin}
          maxWidth="md" // Use 'md' for medium size
          fullWidth
          sx={{
            '& .MuiDialog-paper': { height: '80vh', maxHeight: 'none' }, // Set dialog height
          }}
        >
          <DialogTitle sx={{ padding: '16px', fontWeight: 'bold', zIndex: 1, backgroundColor: 'white' }}>
            Aydınlatma Metni
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              overflow: 'auto',
              padding: '0',
              height: 'calc(100% - 64px)', // Adjust height to leave space for the title and actions
            }}
          >
            <div className="mobile__pdf__container" style={{ height: '100%' }}>
              <Viewer fileUrl={AydinlatmaMetni} plugins={[aydinlatmaToolbarPluginInstance]} />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseMetin} color="primary">
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
      <div style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        zIndex: 1000,
      }}>
        <FilterSpeedDialNew
          OpenChangeList={OpenChangeList}
          SetChangeList={SetChangeList}
          HandleFilterClick={handleOpenModal}
          HandleExportClick={handleExportClick}
          SetEmployeeNew={setEmployeeNew}
          OnFilter={handleFilter}
        />
      </div>
    </Page >
  );
}

export default EmployeeMain;
